import { Typography } from '@one-thd/sui-atomic-components';
import { Filters } from '@one-thd/sui-icons';
import React, { useState } from 'react';
import { FeatureSwitches } from '../../../constants/feature-switches';
import { usePurchaseHistoryContext } from '../../../hooks/useContexts';
import { getFilterDetailsFromSession } from '../../../utils/purchase-history/common';
import { isUserAllowedToViewAllPurchases } from '../../../utils/policy-utils';
import { OrderFilterDrawer } from './OrderFilterDrawer';
import { pushEventInfo } from '../../../utils/analytics';

export const OrderFilter = () => {
  const {
    dateSelectorValue,
    pHRequest,
    customerRole,
    customerType,
    rules,
    triggerPHFilterFetch,
  } = usePurchaseHistoryContext();

  const sessionPHFilter = getFilterDetailsFromSession();

  const permissionRulesCheck: boolean = isUserAllowedToViewAllPurchases(
    customerRole,
    customerType,
    rules,
  );

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [dateFilterDot, setDateFilterDot] = useState<{
    date: boolean;
    user: boolean;
  }>({
    date:
      (sessionPHFilter?.selectedDate ?? dateSelectorValue) !==
      (FeatureSwitches.enableLSSCPS25MonthsDefault
        ? 'last25Months'
        : 'last6Months'),
    user:
      // Only show the dot when the user has explicitly saved a filter to session.
      // Falling back to pHRequest.resultsFilter would incorrectly trigger the dot
      // because the safe B2B default is 'myOrders' before policies load.
      permissionRulesCheck
        ? (sessionPHFilter?.userView ?? pHRequest?.resultsFilter) !==
          'allOrders'
        : false,
  });

  const openFilterDrawer = () => {
    pushEventInfo({
      category: { primaryCategory: 'overlay' },
      eventInfo: { eventName: 'purchase history: date filter' },
    });
    setIsDrawerOpen(true);
    triggerPHFilterFetch?.();
  };

  return (
    <>
      <div
        className="sui-flex sui-flex-col sui-items-center sui-cursor-pointer sui-ml-[12px] sui-relative"
        onClick={openFilterDrawer}
        onKeyDown={openFilterDrawer}
        role="button"
        tabIndex={0}
      >
        {(dateFilterDot.date || dateFilterDot.user) && (
          <div
            style={{
              position: 'absolute',
              top: '-2px',
              left: '24px',
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              backgroundColor: 'rgb(249,99,2)',
              zIndex: 100,
            }}
          />
        )}
        <Filters />
        <Typography color="subtle">Filter</Typography>
      </div>
      <OrderFilterDrawer
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
        dateFilterDot={dateFilterDot}
        setDateFilterDot={setDateFilterDot}
        permissionRulesCheck={permissionRulesCheck}
      />
    </>
  );
};
